<template>
    <v-container fluid class="incidente-root">
        <div>
            <h2>Regimen Disciplinario</h2>
            <!-- Filtros -->
            <v-row>
                <v-col cols="12" lg="12">
                    <div>
                        <en-desarrollo titulo="Régimen Disciplinario" />
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
  
<script>
import axios from 'axios';
import EnDesarrollo from '../EnDesarrollo.vue';

export default {
    components: {
        EnDesarrollo
    },
    data() {
        return {
            datos: [], Larea: [], roles: [], Lestado: [],
            LPais: [], LDepto: [], LCiudad: [], Lgrado: [], Lcargo: [], Lunidad: [], Ldestino: [],
            dato: {
                oid: 0,
                password_hash: 'aa',
                nombres: '',
                primero_apellido: '',
                segundo_apellido: '',
                oid_tipo_documento: null,
                documento: '',
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_depto_nacimiento: null,
                oid_ciudad_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                telefono: '',
                oid_user: null,
                verificado: null,
                activo: null,
                lat: null,
                lng: null,
                oid_estado: null,
                cl1: '',
                cl2: '',
                fecha_ingreso: null,
                fecha_retiro: null,
                fecha_reintegro: null,
                oid_grado: null,
                oid_cargo: null,
                oid_unidad: null,
                oid_destino: null,
            },
            isNew: true,
            Ops: [
                { oid: 1, nombre: 'Si' },
                { oid: 0, nombre: 'No' },
            ],
        };
    },
    computed: {
        headers() {
            const baseHeaders = [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Documento', value: 'documento' },
                { text: 'Nombres', value: 'nombres' },
                { text: 'Primer Apellido', value: 'primero_apellido' },
                { text: 'Segundo Apellido', value: 'segundo_apellido' },
                { text: 'Correo', value: 'correo' },
                // { text: 'Rol', value: 'rol' },
                // { text: 'Área', value: 'area' },
                { text: 'Activo', value: 'activo' },
            ];

            return baseHeaders;
        },
        usernombres() {
            const user = localStorage.getItem('usernombres'); 
            return user;
        },
        rolOid() {
            const oid_rol = localStorage.getItem('rolu');
            return Number(oid_rol);
        },    
        userOid() {
            const oid_user = localStorage.getItem('oidu');
            return Number(oid_user);
        },
    },
    async mounted() {

    },
    methods: {
        
    },
};
</script> 
<style>
    p {
        font-family: 'Heebo', sans-serif !important;
    }
    h1 {
        font-family: 'Heebo', sans-serif !important;
    }
</style>